import {
  AdminBeneficiariesFiltersRoutes,
  AdminBeneficiariesRoutes,
  AdminFeedbacksRoutes,
  AdminResourcesRoutes,
  AlertsRoutes,
  AuthRoutes,
  BeneficiariesFiltersRoutes,
  BeneficiariesFilterTemplatesRoutes,
  BeneficiariesInsightWidgetsRoutes,
  BeneficiariesRoutes,
  CaseWorkersRoutes,
  CaseWorkersRoutes2,
  DemoRoutes,
  DocumentsRoutes,
  FeatureFlagRoutes,
  FilesRoutes,
  OrganizationsRoutes,
  PromptTemplatesRoutes,
  ReportTemplatesRoutes,
  SudoRoutes,
  TasksRoutes,
} from '.'

export enum Routes {
  Admin = 'admin', // Organization Admin
  Alerts = 'alerts',
  Beneficiaries = 'beneficiaries',
  BeneficiariesInsightWidgets = 'beneficiaries-insight-widgets',
  CaseWorkers = 'case-workers',
  ChatMessages = 'chat-messages',
  ChatSessions = 'chat-sessions',
  Demo = 'demo',
  Documents = 'documents',
  Feedbacks = 'feedbacks',
  File = 'file',
  Keywords = 'keywords',
  Onboarding = 'onboarding',
  Organizations = 'organizations',
  Snapshot = 'snapshot',
  PromptTemplates = 'prompt-templates',
  Public = 'public',
  Resources = 'resources',
  Revisions = 'revisions',
  Sudo = 'sudo', // Super Admin
  Tasks = 'tasks',
  Users = 'users',
}

export function countEndpoints(routes: { [key: string]: unknown }): number {
  let count = 0
  for (const key in routes) {
    if (typeof routes[key] === 'object') {
      if (routes[key] && 'path' in routes[key]) {
        count++
      } else count += countEndpoints(routes[key] as { [key: string]: unknown })
    } else if (typeof routes[key] === 'function') {
      count++
    }
  }
  return count
}

export const nonPublicEndpointCount = () =>
  countEndpoints({
    AdminBeneficiariesFiltersRoutes,
    AdminBeneficiariesRoutes,
    AdminFeedbacksRoutes,
    AdminResourcesRoutes,
    AlertsRoutes,
    AuthRoutes,
    BeneficiariesFiltersRoutes,
    BeneficiariesFilterTemplatesRoutes,
    BeneficiariesInsightWidgetsRoutes,
    BeneficiariesRoutes,
    CaseWorkersRoutes,
    CaseWorkersRoutes2,
    DemoRoutes,
    DocumentsRoutes,
    FeatureFlagRoutes,
    FilesRoutes,
    OrganizationsRoutes,
    PromptTemplatesRoutes,
    ReportTemplatesRoutes,
    SudoRoutes,
    TasksRoutes,
  })
